import React from 'react';
import { ITablePagenationParma } from './useTableDataWithPagination';
import Table, { ILineSet, ITableSet } from '../Table';
import Pagination from '../pagination/Pagination';

export default function TableWithPagination<T>(props: {
    param: ITablePagenationParma<T>,
    tableSets: any
    lineSets?: ((rowIndex: number, rowData?: any) => ILineSet) | any;
    className?: string;
}) {

    return (
        <div>
            <Table data={props.param.data} tableSets={props.tableSets} lineSets={props.lineSets} className={props.className} />
            <Pagination
                pageCount={props.param.pageCount}
                lineNum={props.param.lineNum}
                pageNo={props.param.pageNo}
                records={props.param.records}
                onLineNumChange={props.param.setLineNum}
                onPageChange={props.param.update}
            />
        </div>
    )
}